import { canManageProject, canWriteOnProject } from "@linkfluence/models/role";
import { useContextualProjectUserRole } from "./useContextualProjectUserRole";

export function useContextualProjectUserRights() {
  const role = useContextualProjectUserRole();
  return {
    canManage: canManageProject(role),
    canWrite: canWriteOnProject(role),
  };
}
